import { EmployeePayslipDetails } from "../../../../components/company/pay-slip/employee-payslips/EmployeePayslipDetails";

export default function EmployeePayslipDetailsPage(){
    return <EmployeePayslipDetails/>
}